import { firestore } from "firebase/app";

export interface Blog {
  uid: string;
  category: string;
  dateCreated: firestore.Timestamp;
  datePosted?: firestore.Timestamp;
  imageUrl?: string;
  likes: number;
  subtitle: string;
  text: string;
  title: string;
  views: number;
  author: string;
  isLive: boolean;
}

export enum BlogCategories {
  general = "general"
}
